<template>
    <card>
        <h3 class="mb-0" slot="header">{{ $t('users.avatar') }}</h3>

        <p>{{ $t('users.avatar-description') }}</p>

        <dropzone
            v-model="file"
            :url="endpoint"
            :options="options"
            @addedfile="addedFile"
            @error="error"
            @complete="complete"
            @success="success"
            preview-classes="thumbnail"
            inner-preview-classes="inner-thumbnail"
            image-preview-classes="image-thumbnail"
        ></dropzone>

        <div class="text-center font-weight-bold text-warning mb-3" v-if="errorFound">
            <small>{{ $t('users.avatar-error') }}</small>
        </div>
        
        <div class="text-center">
            <base-button v-if="readyToUpload"
                type="primary"
                :loading="uploading"
                @click="upload"
            >
                {{ $t('common.upload') }}
            </base-button>
        </div>
    </card>
</template>

<script>
    export default {

        props: {
            id: {
                type: [String, Number],
                required: true
            },
            user: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                endpoint: this.$baseURL + '/astral/api/front/users/' + this.id + '/avatar',
                options: {
                    autoProcessQueue: false,
                    acceptedFiles: 'image/*',
                    thumbnailWidth: 140,
                    thumbnailHeight: 140,
                    resizeWidth: 140,
                    resizeHeight: 140,
                    resizeQuality: 1.0,
                    resizeMethod: 'crop',
                    resizeMimeType: 'image/jpeg',
                },
                file: null,
                dropzone: null,
                readyToUpload: false,
                uploading: false,
                errorFound: false,
            }
        },

        methods: {
            addedFile(event) {
                this.dropzone = event.dropzone
                this.errorFound = false
                this.readyToUpload = true
            },
            upload() {
                this.errorFound = false
                this.uploading = true
                this.dropzone.processQueue()
            },
            complete(event) {
                this.uploading = false
                this.readyToUpload = false
                /*
                this.errorFound = event.args[0].status != 'success'
                */
            },
            error(event) {
                this.errorFound = true
            },
            success(event) {
                this.file = null
                this.dropzone.removeAllFiles()
                this.$emit('changed', event.args[1].data)
            },
        }
    }
</script>

<style scoped>

    .card >>> .thumbnail {
        width: 140px;
        height: 140px;
        left: 50%;
        right: auto;
    }
    .card >>> .inner-thumbnail {
        position: relative;
        left: -50%;
        right: auto;
    }
    .card >>> .image-thumbnail {
        border-radius: 50% !important;
    }

</style>
